module.exports = __webpack_public_path__ + "img/inv.09a24466.jpg";